import React, { useState } from 'react'
import { Form, Input, Button } from 'antd'
import './ClientManagement.css'
import { submitProductEnquiry } from '../../api';
import toast, { Toaster } from 'react-hot-toast';

function ClientManagement() {
  const [menuOpen, setMenuOpen] = useState(false)
  const closeMenu = () => setMenuOpen(false)

  // ================= CONTACT FORM =================
  async function handleContact(values) {
    // Validation — email ya phone mein se ek zaroori
    if (!values.email && !values['Mobile-no']) {
      toast.error("Please enter either Email or Mobile number.");
      return;
    }

    try {
      const result = await submitProductEnquiry({
        name: values.Name,
        email: values.email || "",
        phone: values['Mobile-no'] || "",
        company: values.Address || '',
        product: 'ClientManagement',
        message: values.Address || '',
      });

      if (result.status === 'success') {
        toast.success(
          `Congratulations ${values.Name}! Your form is submitted successfully. We will respond to you as soon as possible.`,
          { duration: 5000 }
        );
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong. Please try again.");
    }
  }

  return (
    <div className="cm-page">
      {/* ✅ Toast Container */}
      <Toaster
        position="top-right"
        containerStyle={{ top: 80, zIndex: 99999 }}
        toastOptions={{ duration: 5000, style: { fontSize: "13px", borderRadius: "10px", maxWidth: "380px" } }}
      />

      {/* NAVBAR */}
      <nav className="cm-navbar">
        <div className="erp-navbar-logo">
          <div className="erp-logo-icon">◈</div>
          <div>Yashvitech<span>+</span><small>Client Management</small></div>
        </div>

        <div className={`cm-navbar-links ${menuOpen ? "cm-navbar-open" : ""}`}>
          <a href="#cm-home" onClick={closeMenu}>Home</a>
          <a href="#cm-about" onClick={closeMenu}>About</a>
          <a href="#cm-features" onClick={closeMenu}>Features</a>
          <a href="#cm-clients" onClick={closeMenu}>Clients</a>
          <a href="#cm-faq" onClick={closeMenu}>FAQ</a>
          <a href="#cm-contact" onClick={closeMenu}>Contact</a>
        </div>

        <a href="#cm-contact" className="cm-navbar-button cm-desktop-cta">Get Started<span>↗</span></a>

        <button className={`cm-navbar-toggle ${menuOpen ? "cm-toggle-active" : ""}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
          <span></span><span></span><span></span>
        </button>
      </nav>

      {/* HOME SECTION */}
      <section id="cm-home" className="cm-home-section">
        <div className="cm-home-left">
          <div className="cm-home-badge"><span className="cm-badge-dot"></span>SMART CLIENT MANAGEMENT</div>
          <h1>Build Stronger<br /><span>Client Relationships.</span><br />Grow Your Business.</h1>
          <p className="cm-home-text">A powerful client management system designed to help businesses organize client information, track relationships, manage communication, monitor activities and build stronger long-term connections.</p>
          <div className="cm-home-actions">
            <a href="#cm-clients" className="cm-home-main-btn">Explore Clients<span>↗</span></a>
            <a href="#cm-about" className="cm-home-outline-btn">Discover More</a>
          </div>
          <div className="cm-home-trust">
            <div className="cm-trust-avatars"><div>MK</div><div>RS</div><div>AK</div><div>+</div></div>
            <div className="cm-trust-content"><strong>Trusted Client Management</strong><span>Built for modern businesses</span></div>
          </div>
        </div>

        <div className="cm-home-right">
          <div className="cm-hero-glow"></div>
          <div className="cm-hero-image-box">
            <img src="https://images.unsplash.com/photo-1556761175-4b46a572b786?auto=format&fit=crop&w=1600&q=90" alt="Client Management" />
            <div className="cm-image-overlay"></div>
            <div className="cm-hero-top-card">
              <div className="cm-top-card-icon">✓</div>
              <div><span>Client Status</span><strong>All Clients Active</strong></div>
              <div className="cm-online-dot"></div>
            </div>
            <div className="cm-hero-stock-card">
              <span>Total Clients</span>
              <div className="cm-stock-number">1,248</div>
              <div className="cm-stock-growth"><span>↗ 12.8%</span><small>vs last month</small></div>
            </div>
            <div className="cm-hero-bottom-card">
              <div className="cm-bottom-title"><span>Client Activity</span><small>Today</small></div>
              <div className="cm-stock-bars">
                <div className="cm-bar cm-bar-one"></div><div className="cm-bar cm-bar-two"></div>
                <div className="cm-bar cm-bar-three"></div><div className="cm-bar cm-bar-four"></div>
                <div className="cm-bar cm-bar-five"></div><div className="cm-bar cm-bar-six"></div>
                <div className="cm-bar cm-bar-seven"></div>
              </div>
              <div className="cm-stock-labels"><span>Mon</span><span>Tue</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span><span>Sun</span></div>
            </div>
          </div>
          <div className="cm-products-added-card">
            <div className="cm-product-mini-icon">👥</div>
            <div className="cm-product-mini-content"><span>New Clients</span><strong>+36 Today</strong></div>
          </div>
        </div>

        <div className="cm-home-bottom-stats">
          <div className="cm-stat-item"><strong>10K+</strong><span>Clients Managed</span></div>
          <div className="cm-stat-line"></div>
          <div className="cm-stat-item"><strong>99.9%</strong><span>Data Reliability</span></div>
          <div className="cm-stat-line"></div>
          <div className="cm-stat-item"><strong>24/7</strong><span>Client Access</span></div>
          <div className="cm-stat-line"></div>
          <div className="cm-stat-item"><strong>Smart</strong><span>Business Insights</span></div>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section id="cm-about" className="cm-about-section">
        <div className="cm-about-image-area">
          <div className="cm-about-main-image"><img src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1600&q=90" alt="Client Meeting" /></div>
          <div className="cm-about-small-image"><img src="https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1600&q=90" alt="Business Management" /></div>
          <div className="cm-about-experience-card"><strong>01</strong><div><span>Powerful</span><small>Client Management</small></div></div>
          <div className="cm-about-circle"><span>SMART</span><strong>CLIENTS</strong></div>
        </div>

        <div className="cm-about-content">
          <div className="cm-about-tag"><span></span>ABOUT CLIENT MANAGEMENT</div>
          <h2>Everything Your<br />Business Needs To<br /><span>Manage Clients Better.</span></h2>
          <p className="cm-about-intro">Our Client Management System is a modern business solution created to simplify the way organizations manage their clients, contacts, communication and relationships.</p>
          <p className="cm-about-description">Instead of maintaining client information across spreadsheets, notebooks, emails and multiple disconnected platforms, businesses can maintain important client data inside one centralized workspace.</p>

          <div className="cm-about-features">
            <div className="cm-about-feature"><div className="cm-feature-icon">◈</div><div><h3>Centralized Client Data</h3><p>Keep client profiles, contact information, business details and important records organized in one secure workspace.</p></div></div>
            <div className="cm-about-feature"><div className="cm-feature-icon">◇</div><div><h3>Better Relationship Visibility</h3><p>Quickly understand client activity, communication history, current status and important relationship information.</p></div></div>
            <div className="cm-about-feature"><div className="cm-feature-icon">↗</div><div><h3>Business Efficiency</h3><p>Reduce repetitive manual work and give your team a structured way to manage daily client operations.</p></div></div>
          </div>

          <a href="#cm-features" className="cm-about-button">Explore Features<span>↗</span></a>
        </div>

        <div className="cm-about-bottom">
          <div><strong>01</strong><span>Organized Clients</span></div>
          <div><strong>02</strong><span>Better Communication</span></div>
          <div><strong>03</strong><span>Strong Relationships</span></div>
          <div><strong>04</strong><span>Complete Control</span></div>
        </div>
      </section>

      {/* FEATURES SECTION */}
      <section id="cm-features" className="cm-features-section">
        <div className="cm-features-header">
          <div className="cm-features-heading">
            <div className="cm-features-tag"><span></span>POWERFUL FEATURES</div>
            <h2>Everything You Need<br />To Manage <span>Smarter.</span></h2>
          </div>
          <p className="cm-features-intro">From client onboarding and contact management to communication tracking, business insights and relationship monitoring, our platform brings essential capabilities together.</p>
        </div>

        <div className="cm-features-grid">
          <div className="cm-feature-card cm-feature-large">
            <div className="cm-feature-card-top"><div className="cm-feature-number">01</div><div className="cm-feature-card-icon">◈</div></div>
            <div className="cm-feature-card-content">
              <h3>Smart Client Tracking</h3>
              <p>Maintain a complete overview of every client. Track client profiles, relationship status, business category, communication history and important activities.</p>
            </div>
            <div className="cm-inventory-mini-ui">
              <div className="cm-mini-ui-header"><span>Client Overview</span><small>Live</small></div>
              <div className="cm-mini-stock-row"><span>Active Clients</span><div className="cm-mini-progress"><div className="cm-progress-one"></div></div><strong>86%</strong></div>
              <div className="cm-mini-stock-row"><span>Follow-ups</span><div className="cm-mini-progress"><div className="cm-progress-two"></div></div><strong>64%</strong></div>
              <div className="cm-mini-stock-row"><span>Retention</span><div className="cm-mini-progress"><div className="cm-progress-three"></div></div><strong>92%</strong></div>
            </div>
          </div>

          <div className="cm-feature-card">
            <div className="cm-feature-card-top"><div className="cm-feature-number">02</div><div className="cm-feature-card-icon">↗</div></div>
            <h3>Real-Time Client Insights</h3>
            <p>Get a clearer picture of your client relationships through useful statistics, activity information and visual business indicators.</p>
            <div className="cm-insight-chart">
              <div className="cm-chart-line cm-line-one"></div><div className="cm-chart-line cm-line-two"></div>
              <div className="cm-chart-line cm-line-three"></div><div className="cm-chart-line cm-line-four"></div>
              <div className="cm-chart-line cm-line-five"></div>
            </div>
            <div className="cm-chart-label"><span>Client engagement</span><strong>+18.4%</strong></div>
          </div>

          <div className="cm-feature-card">
            <div className="cm-feature-card-top"><div className="cm-feature-number">03</div><div className="cm-feature-card-icon">!</div></div>
            <h3>Follow-Up Alerts</h3>
            <p>Never lose track of important client conversations, scheduled follow-ups, pending responses or relationship opportunities.</p>
            <div className="cm-alert-ui">
              <div className="cm-alert-item"><div className="cm-alert-dot"></div><div><strong>Rahul Industries</strong><span>Follow-up due today</span></div><small>HIGH</small></div>
              <div className="cm-alert-item"><div className="cm-alert-dot"></div><div><strong>Apex Solutions</strong><span>Response pending</span></div><small>WATCH</small></div>
            </div>
          </div>

          <div className="cm-feature-card">
            <div className="cm-feature-card-top"><div className="cm-feature-number">04</div><div className="cm-feature-card-icon">#</div></div>
            <h3>Client Organization</h3>
            <p>Keep client information structured using categories, industries, relationship status, account type and important business details.</p>
            <div className="cm-category-ui">
              <div><span>Enterprise</span><strong>124</strong></div>
              <div><span>Startups</span><strong>86</strong></div>
              <div><span>Businesses</span><strong>218</strong></div>
            </div>
          </div>

          <div className="cm-feature-card cm-feature-wide">
            <div className="cm-feature-wide-content">
              <div className="cm-feature-card-top"><div className="cm-feature-number">05</div><div className="cm-feature-card-icon">◇</div></div>
              <h3>Centralized Business Control</h3>
              <p>Manage client information, relationship activities, follow-ups and communication from a single organized system.</p>
            </div>
            <div className="cm-control-ui">
              <div className="cm-control-circle"><span>CLIENTS</span><strong>92%</strong><small>Healthy</small></div>
              <div className="cm-control-stats">
                <div><strong>1,248</strong><span>Clients</span></div>
                <div><strong>326</strong><span>Leads</span></div>
                <div><strong>98%</strong><span>Accuracy</span></div>
              </div>
            </div>
          </div>
        </div>

        <div className="cm-features-bottom">
          <div><strong>01</strong><span>Track Everyone</span></div>
          <div><strong>02</strong><span>Understand Data</span></div>
          <div><strong>03</strong><span>Never Miss Follow-ups</span></div>
          <div><strong>04</strong><span>Grow Relationships</span></div>
        </div>
      </section>

      {/* CLIENT SECTION */}
      <section id="cm-clients" className="cm-inventory-section">
        <div className="cm-inventory-header">
          <div>
            <div className="cm-inventory-tag"><span></span>CLIENT OVERVIEW</div>
            <h2>Your Clients.<br /><span>Your Relationships.</span></h2>
          </div>
          <p>Monitor your clients, relationship status, communication activity and business performance from one clean and organized workspace.</p>
        </div>

        <div className="cm-inventory-dashboard">
          <div className="cm-dashboard-top">
            <div><span>Overview</span><h3>Client Dashboard</h3></div>
            <div className="cm-dashboard-date"><span>●</span>Live Clients</div>
          </div>

          <div className="cm-inventory-stats">
            <div className="cm-inventory-stat-card"><div className="cm-stat-icon">◈</div><div><span>Total Clients</span><strong>1,248</strong></div><small>+12.8%</small></div>
            <div className="cm-inventory-stat-card"><div className="cm-stat-icon">◇</div><div><span>Active Clients</span><strong>1,096</strong></div><small>+8.4%</small></div>
            <div className="cm-inventory-stat-card"><div className="cm-stat-icon">!</div><div><span>Follow-ups</span><strong>86</strong></div><small className="cm-warning-text">Attention</small></div>
            <div className="cm-inventory-stat-card"><div className="cm-stat-icon">↗</div><div><span>Categories</span><strong>24</strong></div><small>+4 new</small></div>
          </div>

          <div className="cm-inventory-main-grid">
            <div className="cm-products-panel">
              <div className="cm-panel-heading">
                <div><span>CLIENTS</span><h3>Recent Clients</h3></div>
                <button>View All →</button>
              </div>

              <div className="cm-product-table">
                <div className="cm-product-table-head"><span>Client</span><span>Category</span><span>Activity</span><span>Status</span></div>

                <div className="cm-product-row">
                  <div className="cm-product-info">
                    <div className="cm-product-image"><img src="https://i.pravatar.cc/150?img=12" alt="Client" /></div>
                    <div><strong>Rahul Industries</strong><span>CLT-00124</span></div>
                  </div>
                  <span className="cm-product-category">Enterprise</span>
                  <strong className="cm-product-stock">24</strong>
                  <span className="cm-status cm-status-available">Active</span>
                </div>

                <div className="cm-product-row">
                  <div className="cm-product-info">
                    <div className="cm-product-image"><img src="https://i.pravatar.cc/150?img=32" alt="Client" /></div>
                    <div><strong>Apex Solutions</strong><span>CLT-00281</span></div>
                  </div>
                  <span className="cm-product-category">Technology</span>
                  <strong className="cm-product-stock">18</strong>
                  <span className="cm-status cm-status-available">Active</span>
                </div>

                <div className="cm-product-row">
                  <div className="cm-product-info">
                    <div className="cm-product-image"><img src="https://i.pravatar.cc/150?img=47" alt="Client" /></div>
                    <div><strong>Vision Creative</strong><span>CLT-00319</span></div>
                  </div>
                  <span className="cm-product-category">Creative</span>
                  <strong className="cm-product-stock">12</strong>
                  <span className="cm-status cm-status-low-stock">Follow-up</span>
                </div>

                <div className="cm-product-row">
                  <div className="cm-product-info">
                    <div className="cm-product-image"><img src="https://i.pravatar.cc/150?img=56" alt="Client" /></div>
                    <div><strong>Digital Works</strong><span>CLT-00412</span></div>
                  </div>
                  <span className="cm-product-category">Digital</span>
                  <strong className="cm-product-stock">31</strong>
                  <span className="cm-status cm-status-available">Active</span>
                </div>
              </div>
            </div>

            <div className="cm-inventory-side-panel">
              <div className="cm-panel-heading"><div><span>CLIENT HEALTH</span><h3>Overview</h3></div><span className="cm-health-dot">●</span></div>
              <div className="cm-stock-circle"><div><strong>92%</strong><span>Healthy</span></div></div>
              <div className="cm-health-info">
                <div><span>Active Clients</span><strong>1,096</strong></div>
                <div><span>Follow-ups</span><strong>86</strong></div>
                <div><span>Inactive</span><strong>66</strong></div>
              </div>
            </div>
          </div>

          <div className="cm-inventory-bottom">
            <div className="cm-inventory-chart-panel">
              <div className="cm-panel-heading"><div><span>PERFORMANCE</span><h3>Client Activity</h3></div><span className="cm-chart-growth">+18.4%</span></div>
              <div className="cm-bar-chart">
                <div className="cm-chart-bar cm-bar-one"><span></span></div><div className="cm-chart-bar cm-bar-two"><span></span></div>
                <div className="cm-chart-bar cm-bar-three"><span></span></div><div className="cm-chart-bar cm-bar-four"><span></span></div>
                <div className="cm-chart-bar cm-bar-five"><span></span></div><div className="cm-chart-bar cm-bar-six"><span></span></div>
                <div className="cm-chart-bar cm-bar-seven"><span></span></div>
              </div>
              <div className="cm-chart-days"><span>Mon</span><span>Tue</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span><span>Sun</span></div>
            </div>

            <div className="cm-quick-panel">
              <div className="cm-panel-heading"><div><span>QUICK ACTIONS</span><h3>Manage Clients</h3></div></div>
              <div className="cm-quick-actions">
                <div className="cm-quick-action"><div>+</div><span>Add Client</span><strong>→</strong></div>
                <div className="cm-quick-action"><div>◇</div><span>Client Categories</span><strong>→</strong></div>
                <div className="cm-quick-action"><div>!</div><span>Check Follow-ups</span><strong>→</strong></div>
              </div>
            </div>
          </div>
        </div>

        <div className="cm-inventory-bottom-text">
          <span>CLIENTLY</span>
          <p>Better client management starts with better relationships.</p>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section id="cm-faq" className="cm-faq-section">
        <div className="cm-faq-header">
          <div className="cm-faq-heading">
            <div className="cm-faq-tag"><span></span>FREQUENTLY ASKED QUESTIONS</div>
            <h2>Everything You<br />Need To <span>Know.</span></h2>
          </div>
          <p className="cm-faq-intro">Find clear answers to common questions about client management, customer relationships, communication tracking, follow-ups and more.</p>
        </div>

        <div className="cm-faq-main">
          <div className="cm-faq-left">
            <div className="cm-faq-info-card">
              <div className="cm-faq-info-top">
                <div className="cm-faq-info-icon">?</div>
                <span>NEED MORE HELP?</span>
              </div>
              <h3>Still have<br />questions?</h3>
              <p>Our support team is ready to help you understand the client management platform and find the right solution.</p>
              <a href="#cm-contact" className="cm-faq-contact-btn">Talk To Our Team<span>↗</span></a>
            </div>

            <div className="cm-faq-mini-stats">
              <div><strong>24/7</strong><span>Access</span></div>
              <div><strong>99.9%</strong><span>Reliability</span></div>
              <div><strong>100%</strong><span>Visibility</span></div>
            </div>
          </div>

          <div className="cm-faq-list">
            <details className="cm-faq-item" open>
              <summary>
                <div className="cm-faq-question"><span className="cm-faq-number">01</span><h3>What is a Client Management System?</h3></div>
                <div className="cm-faq-toggle">+</div>
              </summary>
              <div className="cm-faq-answer"><p>A Client Management System is a centralized platform that helps businesses organize client information, contact details, communication history, follow-ups, relationship status and other important business records.</p></div>
            </details>

            <details className="cm-faq-item">
              <summary>
                <div className="cm-faq-question"><span className="cm-faq-number">02</span><h3>How does client management help a business?</h3></div>
                <div className="cm-faq-toggle">+</div>
              </summary>
              <div className="cm-faq-answer"><p>It helps businesses maintain organized client information, reduce manual work, improve communication, manage follow-ups and get a clearer understanding of customer relationships.</p></div>
            </details>

            <details className="cm-faq-item">
              <summary>
                <div className="cm-faq-question"><span className="cm-faq-number">03</span><h3>Can I track client follow-ups?</h3></div>
                <div className="cm-faq-toggle">+</div>
              </summary>
              <div className="cm-faq-answer"><p>Yes. The system is designed to make pending conversations, follow-ups and client activities easier to identify.</p></div>
            </details>

            <details className="cm-faq-item">
              <summary>
                <div className="cm-faq-question"><span className="cm-faq-number">04</span><h3>Can client information be managed centrally?</h3></div>
                <div className="cm-faq-toggle">+</div>
              </summary>
              <div className="cm-faq-answer"><p>Yes. Client details, contact information, business categories, relationship status, communication records and other important information can be maintained inside one structured workspace.</p></div>
            </details>

            <details className="cm-faq-item">
              <summary>
                <div className="cm-faq-question"><span className="cm-faq-number">05</span><h3>Does the system provide client insights?</h3></div>
                <div className="cm-faq-toggle">+</div>
              </summary>
              <div className="cm-faq-answer"><p>The platform can provide useful client statistics, activity information and relationship indicators that help businesses understand customer engagement.</p></div>
            </details>

            <details className="cm-faq-item">
              <summary>
                <div className="cm-faq-question"><span className="cm-faq-number">06</span><h3>Who can benefit from client management?</h3></div>
                <div className="cm-faq-toggle">+</div>
              </summary>
              <div className="cm-faq-answer"><p>Client management can benefit agencies, service companies, startups, consultants, sales teams, marketing teams, growing businesses and organizations that regularly communicate with customers.</p></div>
            </details>
          </div>
        </div>

        <div className="cm-faq-bottom">
          <div><strong>01</strong><span>Clear Answers</span></div>
          <div><strong>02</strong><span>Smart Management</span></div>
          <div><strong>03</strong><span>Better Relationships</span></div>
          <div><strong>04</strong><span>Complete Support</span></div>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section id="cm-contact" className="cm-contact-section">
        <div className="cm-contact-container">
          <div className="cm-contact-content">
            <p className="cm-contact-tag">GET IN TOUCH</p>
            <h2>Let's Talk About<br />Your <span>Business.</span></h2>
            <p className="cm-contact-description">Have questions about client management, customer relationships or business operations? Send us a message and the YashviTech team will get back to you.</p>

            <div className="cm-contact-info">
              <div className="cm-contact-info-card"><div className="cm-contact-icon">✉</div><div><span>Email</span><strong>info.yashvitecch@gmail.com</strong></div></div>
              <div className="cm-contact-info-card"><div className="cm-contact-icon">☎</div><div><span>Phone</span><strong>+91 86400 91593</strong></div></div>
              <div className="cm-contact-info-card"><div className="cm-contact-icon">⌖</div><div><span>Location</span><strong>Near Disha College, Kota, Raipur, C.G.</strong></div></div>
            </div>
          </div>

          <div className="cm-contact-form-card">
            <div className="cm-form-heading">
              <span>CONTACT FORM</span>
              <h3>Send us a message</h3>
              <p>Fill in the details below and we'll contact you shortly.</p>
            </div>

            <Form layout="vertical" onFinish={handleContact}>
              <Form.Item label="Your Name" name="Name" rules={[{ required: true, message: 'Please enter your name' }]}>
                <Input placeholder="Enter your name" />
              </Form.Item>

              <Form.Item label="Email Address (optional)" name="email">
                <Input placeholder="you@example.com" />
              </Form.Item>

              <Form.Item label="Mobile Number (optional)" name="Mobile-no">
                <Input placeholder="Enter your mobile number" />
              </Form.Item>

              <Form.Item label="Address" name="Address" rules={[{ required: true, message: 'Please enter your address' }]}>
                <Input.TextArea rows={4} placeholder="Enter your address" />
              </Form.Item>

              {/* ✅ Submit Button को Form.Item के अंदर रैप किया और type="primary" जोड़ा */}
              <Form.Item style={{ marginBottom: 0, marginTop: 15 }}>
                <Button type="primary" htmlType="submit" className="cm-contact-submit-btn">
                  Send Message <span>→</span>
                </Button>
              </Form.Item>

              {/* ✅ इस छोटे नोट को Form.Item के बाहर रखा ताकि मार्जिन सही रहे */}
              <small style={{ display: "block", textAlign: "center", fontSize: "11px", color: "#94a3b8", marginTop: "12px" }}>
                Enter at least one — Email or Mobile — so we can reach you back.
              </small>
            </Form>
          </div>
        </div>

        <div className="cm-contact-bottom">
          <div><strong>01</strong><span>Quick Response</span></div>
          <div><strong>02</strong><span>Secure Data</span></div>
          <div><strong>03</strong><span>Professional Support</span></div>
          <div><strong>04</strong><span>Client First</span></div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="cm-footer">
        <div className="cm-footer-main">
          <div className="cm-footer-company">
            <div className="cm-footer-logo"><img src="/yashvitechh.png" alt="YashviTech" /></div>
            <p>Building secure, scalable and future-ready digital solutions for modern businesses.</p>
            <a href="#cm-contact" className="cm-footer-button">Get Started<span>↗</span></a>
          </div>

          <div className="cm-footer-column">
            <h3>QUICK LINKS</h3>
            <a href="#cm-home">Home</a>
            <a href="#cm-about">About</a>
            <a href="#cm-features">Features</a>
            <a href="#cm-clients">Clients</a>
            <a href="#cm-contact">Contact</a>
          </div>

          <div className="cm-footer-column">
            <h3>FEATURES</h3>
            <a href="#cm-features">Client Tracking</a>
            <a href="#cm-features">Client Analytics</a>
            <a href="#cm-features">Communication</a>
            <a href="#cm-features">Follow-up Alerts</a>
            <a href="#cm-features">Relationship Management</a>
          </div>

          <div className="cm-footer-column cm-footer-contact">
            <h3>GET IN TOUCH</h3>
            <div><span>EMAIL</span><strong>info.yashvitecch@gmail.com</strong></div>
            <div><span>PHONE</span><strong>+91 86400 91593</strong></div>
            <div><span>LOCATION</span><strong>Near Disha College, Kota, Raipur, C.G.</strong></div>
          </div>
        </div>

        <div className="cm-footer-bottom">
          <p>© 2026 <strong>YashviTech</strong>. All rights reserved.</p>
          <div className="cm-footer-bottom-links"><a href="#cm-home">Privacy</a><a href="#cm-home">Terms</a></div>
          <p className="cm-footer-made">Built for <span>smarter</span> client relationships.</p>
        </div>
      </footer>
    </div>
  )
}

export default ClientManagement